import { BUTTON_COLOR } from "../colors";

export default function LoadingButton(theme) {
    const disabledStyle = {
        '&.Mui-disabled': {
            backgroundColor: theme.palette.grey[200]
        }
    };

    return {
        MuiLoadingButton: {
            defaultProps: {
                disableElevation: true,
                // backgroundColor: BUTTON_COLOR
            },
            styleOverrides: {
                root: {
                    fontWeight: 500
                },
                contained: {
                    ...disabledStyle
                },
                outlined: {
                    ...disabledStyle
                }
            }
        }
    }
}